import React from 'react';
import { useSortBy } from 'react-instantsearch';
import { RefinementItem } from '../../../utils/types';
import { pushToDataLayer } from '@jbhi-fi/utils/src/ga4Tracking/datalayer';
import { SortBySelect } from './SortBySelect';

type CustomSortByProps = {
  items: Array<RefinementItem<string>>;
  searchTerm: string;
  defaultRefinement?: string;
};
const SortBy: React.FC<CustomSortByProps> = props => {
  const { items, searchTerm } = props;
  const { refine, currentRefinement } = useSortBy(props);
  const refinedValue = items.find(item => item.value === currentRefinement);

  const trackSortByChange = (value: string) => {
    window.dataLayer.push({
      event: 'custom.sortBy.set',
      value,
    });
    pushToDataLayer({
      event: 'select_sort',
      filter_name: 'sort by',
      filter_value: value,
      search_type: 'site search',
      search_term: searchTerm,
    });
  };

  const onSortByClick = () => {
    pushToDataLayer({
      event: 'open_sort',
      filter_name: 'sort by',
      search_type: 'site search',
      search_term: searchTerm,
    });
  };

  return (
    <SortBySelect
      items={items}
      currentValue={refinedValue?.value}
      onClick={onSortByClick}
      onChange={(value, label) => {
        refine(value);
        trackSortByChange(label);
      }}
    />
  );
};

const CustomSortBy = SortBy;

export default CustomSortBy;
